import { useContext } from "react";
import {
  WasteStepperContext,
  WasteStepperContextValue,
} from "routes/Customer/Waste/Submissions/Stepper/WasteStepperContextValue";

/**
 * Reads the waste stepper context. Must be called inside `WasteSubmissionStepper`
 * (the shell), which provides the resolved submission, facility id, and derived
 * per-step display states.
 */
export function useWasteStepper(): WasteStepperContextValue {
  const ctx = useContext(WasteStepperContext);
  if (!ctx) {
    throw new Error("useWasteStepper must be used within a WasteStepperProvider");
  }
  return ctx;
}
